import { useState, useEffect, useCallback } from 'react';
import adminClient, { removeStoredToken } from '../api/adminClient';

interface AuthCheckState {
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
}

export const useAuthCheck = () => {
  const [authState, setAuthState] = useState<AuthCheckState>({
    isAuthenticated: false,
    loading: true,
    error: null,
  });

  const [hasChecked, setHasChecked] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      setAuthState((prev) => ({ ...prev, loading: true, error: null }));

      const token = localStorage.getItem('adminToken');
      if (!token) {
        // Access истёк, но refresh-cookie ещё может жить
        try {
          const refreshResponse = await adminClient.post('/admin/refresh');
          if (
            refreshResponse.status === 201 &&
            refreshResponse.data?.accessToken
          ) {
            localStorage.setItem(
              'adminToken',
              refreshResponse.data.accessToken,
            );
            setAuthState({
              isAuthenticated: true,
              loading: false,
              error: null,
            });
            return true;
          }
        } catch {
          setAuthState({
            isAuthenticated: false,
            loading: false,
            error: 'No token',
          });
          return false;
        }
      }

      const response = await adminClient.get('/admin/check');

      if (response.status === 200) {
        setAuthState({
          isAuthenticated: true,
          loading: false,
          error: null,
        });
        return true;
      }

      throw new Error('Неожиданный ответ сервера');
    } catch (error: any) {
      removeStoredToken();
      setAuthState({
        isAuthenticated: false,
        loading: false,
        error: error?.message || 'Auth error',
      });
      return false;
    }
  }, []);

  useEffect(() => {
    if (!hasChecked) {
      checkAuth();
      setHasChecked(true);
    }
  }, [hasChecked, checkAuth]);

  return {
    ...authState,
    checkAuth,
  };
};
